function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// kapigen version 0.1.12
// tslint:disable
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
export var DeleteActiveEventRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultFirebaseConfig = {
    apiKey: "",
    authDomain: "",
    databaseUrl: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    proxyDomain: ""
};
export var FirebaseConfigWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFirebaseConfig, wireFormat);
        return message;
    }
};
export var GetActiveEventsFirebaseConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetActiveEventsFirebaseConfigResponse = {
    authToken: ""
};
export var GetActiveEventsFirebaseConfigResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetActiveEventsFirebaseConfigResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.config) {
            message.config = FirebaseConfigWireFormat3.fromJson(wireFormat.config);
        }
        return message;
    }
};
export var activeEventsClient = {
    activeEventService: {
        // DeleteActiveEvent deletes the specified ActiveEvent from firestore under the current user.
        deleteActiveEvent: createClient(DeleteActiveEventRequestWireFormat3, google.protobuf.EmptyWireFormat3, "active_events.ActiveEventService/DeleteActiveEvent"),
        getActiveEventsFirebaseConfig: createClient(GetActiveEventsFirebaseConfigRequestWireFormat3, GetActiveEventsFirebaseConfigResponseWireFormat3, "active_events.ActiveEventService/GetActiveEventsFirebaseConfig")
    }
};
